export const buttonCommon = {
  key: 'buttonCommon',
  name: 'Button Common',
  siteIdentifier: 'global',

  editButton: 'Edit',
  deleteButton: 'Delete',
  cancelButton: 'Cancel',
};
